import React from 'react';

import * as MODAL_TYPES from '@project/consts/modalTypes';

import AlertModal from "@project/components/Modals/Alert";
import FeedbackModal from "@project/components/Modals/Feedback";
import OrderStatusModal from '@project/components/Modals/OrderStatus';
import OrderTrackingModal from '@project/components/Modals/OrderTracking';
import PromoCodeModal from "@project/components/Modals/PromoCode";
import SelectPlatformModal from '@project/components/Modals/SelectPlatform';
import SelectBankModal from '@project/components/Modals/SelectBank';
import TipsModal from "@project/components/Modals/Tips";

const modalTypeMap = {
    [MODAL_TYPES.ALERT]: AlertModal,
    [MODAL_TYPES.TIPS]: TipsModal,
    [MODAL_TYPES.PROMO_CODE]: PromoCodeModal,
    [MODAL_TYPES.FEEDBACK]: FeedbackModal,
    [MODAL_TYPES.ORDER_STATUS]: OrderStatusModal,
    [MODAL_TYPES.ORDER_TRACKING]: OrderTrackingModal,
    [MODAL_TYPES.SELECT_PLATFORM]: SelectPlatformModal,
    [MODAL_TYPES.SELECT_BANK]: SelectBankModal,
};

const Modal = (props) => {
    const { type, setShownModal } = props;
    const ModalCompoent = modalTypeMap[type];

    if (!ModalCompoent) return null;

    return <ModalCompoent
        {...props.props}
        show={!!type}
        onClose={() => setShownModal()}
    />
};

export default Modal;
